interface Props {
  title: string;
  description: string;
  buttonLabel: string;
  buttonTarget: string;
}

const SurfCtaSection = ({ title, description, buttonLabel, buttonTarget }: Props) => {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    const target = buttonTarget?.startsWith("#")
      ? document.querySelector(buttonTarget)
      : null;
    if (target) {
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <section className="py-14 md:py-20 bg-gradient-to-br from-primary via-primary to-accent/40 text-white">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-bold">{title}</h2>
        <p className="mt-4 text-base md:text-lg text-white/90 leading-relaxed">{description}</p>
        <div className="mt-8">
          <a
            href={buttonTarget || "#booking"}
            onClick={handleClick}
            className="inline-block px-8 py-4 rounded-full bg-primary hover:bg-accent text-white font-semibold text-base md:text-lg shadow-lg hover:shadow-xl transition-all hover:-translate-y-0.5"
          >
            {buttonLabel || "Choisir mon créneau maintenant"} →
          </a>
        </div>
      </div>
    </section>
  );
};

export default SurfCtaSection;